export type KillSwitchModule =
  | "PAYMENTS"
  | "PMS"
  | "PARTNERS"
  | "COMMUNICATION_CHANNELS"
  | "WHATSAPP";

export const KILL_SWITCH_MODULES: readonly KillSwitchModule[] = [
  "PAYMENTS",
  "PMS",
  "PARTNERS",
  "COMMUNICATION_CHANNELS",
  "WHATSAPP",
] as const;

export interface KillSwitchState {
  module: KillSwitchModule;
  enabled: boolean;
  lastToggledAt: string | null;
  lastToggledByUserId: string | null;
  lastReason: string | null;
}

export interface ToggleModuleRequest {
  enabled: boolean;
  reason: string | null;
}

export interface ModuleAuditEntry {
  id: string;
  module: KillSwitchModule;
  previousEnabled: boolean;
  nextEnabled: boolean;
  reason: string | null;
  userId: string;
  createdAt: string;
}

export interface ModuleAuditQuery {
  module?: KillSwitchModule;
  userId?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface ModuleAuditResponse {
  total: number;
  page: number;
  limit: number;
  data: ModuleAuditEntry[];
}
